/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import ColorPicker from "../../ColorPicker.vue";

export default function ColorPickerWrapper({ value, onChange, ...restProps }: any) {
  const colors = [
    "#FFFFFF",
    "#000000",
    "#D50132",
    "#FA4617",
    "#FEB414",
    "#1261A9",
    "#432F92",
    "#008080",
    "#B6E4E4",
    "#C7B1EA",
    "#FDA398"
  ];

  function handleChange(selectedColor: any) {
    onChange(selectedColor);
  }

  return (
    <ColorPicker
      {...restProps}
      value={value}
      colors={colors}
      variant="inline"
      onChange={handleChange}
      data-testid="color-picker"
    />
  );
}
